import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiPlay } from 'react-icons/fi';

const DemoVideo = () => {
  return (
    <section className="w-full py-24 px-6 bg-white border-b-4 border-black">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-yellow-300 border-2 border-black px-4 py-1 mb-4 font-black text-sm brutal-shadow-sm uppercase">
            <SafeIcon icon={FiPlay} className="w-4 h-4" />
            Watch the Demo
          </div>
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter">
            SEE HOW ETERA WORKS
          </h2>
        </div>

        <div className="relative group">
          {/* Brutalist Frame */}
          <div className="absolute inset-0 bg-black translate-x-3 translate-y-3 md:translate-x-6 md:translate-y-6"></div>
          
          <div className="relative bg-white border-4 border-black overflow-hidden">
            <div className="aspect-video w-full">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/DOl2kGC7NcI"
                title="ETERA.STORE Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          
          {/* Decorative Corner Elements */}
          <div className="absolute -top-4 -left-4 w-8 h-8 bg-black hidden md:block"></div>
          <div className="absolute -bottom-4 -right-4 w-8 h-8 bg-black hidden md:block"></div>
        </div>

        <p className="mt-12 text-center font-bold text-lg md:text-xl max-w-2xl mx-auto italic">
          "The fastest way to manage permanent links without the subscription headache."
        </p>
      </div>
    </section>
  );
};

export default DemoVideo;